import { Components, Theme } from '@mui/material';

export const MuiTabs: Components<Omit<Theme, 'components'>>['MuiTabs'] = {
  styleOverrides: {
    indicator: ({ theme }) => ({
      backgroundColor: theme.palette.brand.purple.main,
    }),
  },
};
